// 收货地址
export default [
	{
		path: '/address/list',
		name: 'AddressList',
		component: () => import('@/views/address/list.vue'),
		meta: { title: '收货地址' }
	},
	{
		path: '/address/create/:id?',
		name: 'CreateAddress',
		component: () => import('@/views/address/create.vue'),
		meta: { title: '添加新地址' }
	}
]
